import { render, staticRenderFns } from "./ItemListDistintaConsumi.vue?vue&type=template&id=6bf507d7"
import script from "./ItemListDistintaConsumi.vue?vue&type=script&lang=ts"
export * from "./ItemListDistintaConsumi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf507d7')) {
      api.createRecord('6bf507d7', component.options)
    } else {
      api.reload('6bf507d7', component.options)
    }
    module.hot.accept("./ItemListDistintaConsumi.vue?vue&type=template&id=6bf507d7", function () {
      api.rerender('6bf507d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListDistintaConsumi.vue"
export default component.exports